import type { ReactNode } from 'react'
import React from 'react'

import { Avatar } from '@fourthwall/components'

import * as S from './styled'

type Props = {
  name: string
  avatarUrl?: string
  shadowbanned?: boolean
  children?: ReactNode
}

export const MobileCell = ({ name, avatarUrl, shadowbanned, children }: Props) => {
  const getAvatar = () => {
    if (!avatarUrl) return

    return avatarUrl
  }

  return (
    <S.Container>
      <S.AvatarContainer>
        <Avatar name={name} imageUrl={getAvatar()} />
      </S.AvatarContainer>
      <S.DetailsContainer>
        {name}
        {shadowbanned && <S.Info>Shadowbanned</S.Info>}
        {children}
      </S.DetailsContainer>
    </S.Container>
  )
}
